import { library, dom } from '@fortawesome/fontawesome-svg-core';

import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF';
import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faTwitterSquare } from '@fortawesome/free-brands-svg-icons/faTwitterSquare';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons/faLinkedin';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';
import { faApple } from '@fortawesome/free-brands-svg-icons/faApple';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons/faCheckCircle';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faPlus } from '@fortawesome/free-solid-svg-icons/faPlus';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { faCircle } from '@fortawesome/free-solid-svg-icons/faCircle';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons/faExclamationTriangle';
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons/faGraduationCap';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope';
import { faPhone } from '@fortawesome/free-solid-svg-icons/faPhone';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/faMapMarkerAlt';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons/faSignInAlt';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons/faSignOutAlt';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons/faFileExcel';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons/faFilePdf';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';

library.add(
    faUser,
    faSpinner,
    faChevronUp,
    faChevronDown,
    faChevronRight,
    faMapMarkerAlt,
    faGraduationCap,
    faCalendarAlt,
    faClock,
    faCheck,
    faCheckCircle,
    faSearch,
    faBars,
    faPlus,
    faTimes,
    faCircle,
    faExclamationCircle,
    faExclamationTriangle,
    faArrowRight,
    faFacebookF,
    faFacebookSquare,
    faInstagram,
    faTwitter,
    faTwitterSquare,
    faLinkedin,
    faLinkedinIn,
    faApple,
    faWhatsapp,
    faSignInAlt,
    faSignOutAlt,
    faFileExcel,
    faFilePdf,
    faEnvelope,
    faPhone,
    faInfoCircle
);

dom.watch();
